var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoPlanReposo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.692,
    height: 34.213,
    viewBox: "0 0 32.692 34.213",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M481.526,353.518a4.495,4.495,0,0,1,.963,6.419,6.045,6.045,0,0,0-.929,4.969.461.461,0,0,1,.028.163c-.019.1-.03.247-.094.283a.35.35,0,0,1-.291-.063,3.939,3.939,0,0,1-1.613-2.366,5.25,5.25,0,0,1,.476-3.556c.393-.829.8-1.657,1.116-2.517a5.162,5.162,0,0,0,.115-2.73,2.625,2.625,0,0,1,.03-.6Z",
    transform: "translate(-463.113 -353.518)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.992,386.32a1.683,1.683,0,0,1,1.824-1.194q11.223.017,22.446.006a1.6,1.6,0,0,1,1.841,1.832q0,3.169,0,6.337a11.718,11.718,0,0,1-3.432,8.516,11.255,11.255,0,0,1-6.653,3.374,22.438,22.438,0,0,1-6.084-.011,11.022,11.022,0,0,1-5.375-2.335,1.668,1.668,0,0,0-1.049-.39,11.9,11.9,0,0,1-4.653-1.025,8.907,8.907,0,0,1-4.831-5.283,9.622,9.622,0,0,1-.614-3.359,6.516,6.516,0,0,1,5.947-6.419C448.568,386.352,448.778,386.337,448.992,386.32Zm3.089,7.429c0,.071-.011.114-.008.158a8.557,8.557,0,0,0,3.371,6.5,8.261,8.261,0,0,0,4.947,1.822,19.683,19.683,0,0,0,4.423-.126,8.573,8.573,0,0,0,6.441-5.057,7.917,7.917,0,0,0,.739-3.3Zm19.924-5.5H452.069V390.9h19.953c0-.8,0-1.573,0-2.349C472.021,388.455,472.011,388.358,472,388.249Zm-23.051,1.209a3.374,3.374,0,0,0-3.449,3.421,6.2,6.2,0,0,0,3.9,5.857c.276.116.569.195.922.314-.076-.167-.109-.248-.148-.327a10.683,10.683,0,0,1-1.166-4.31c-.062-1.52-.042-3.044-.058-4.567C448.952,389.715,448.954,389.585,448.954,389.458Z",
    transform: "translate(-442.411 -371.18)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.8,361.365a4.018,4.018,0,0,1-.749,2.444,4.654,4.654,0,0,0-.755,3.862.788.788,0,0,1,.03.2,3.1,3.1,0,0,1-.05.308.95.95,0,0,1-.293-.092,3.345,3.345,0,0,1-1.354-3.118,5.305,5.305,0,0,1,.727-2.159,5.579,5.579,0,0,0,.827-3.207c-.021-.232-.079-.46-.1-.692a1.713,1.713,0,0,1,.049-.367,1.191,1.191,0,0,1,.321.121A3.288,3.288,0,0,1,494.8,361.365Z",
    transform: "translate(-469.907 -356.325)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPlanReposo);
export default __webpack_public_path__ + "static/media/ICO-PLAN-REPOSO.6638929995aa4d2413df97daf5c537e2.svg";
export { ForwardRef as ReactComponent };